export default __webpack_public_path__ + "static/media/RecommendedContact.e5f5ce39.svg";